import { Container, Row, Col } from 'react-bootstrap';

export default function PageHero({ eyebrow, title, intro, action }) {
  return (
    <section className="page-hero-section">
      <Container>
        <Row className="align-items-center g-4">
          <Col lg={action ? 8 : 12}>
            <div className="page-hero-content">
              {eyebrow && <p className="page-eyebrow">{eyebrow}</p>}

              <h1 className="display-4 fw-bold text-white mb-3">
                {title}
              </h1>

              {intro && (
                <p className="lead text-eac-grey mb-0">
                  {intro}
                </p>
              )}
            </div>
          </Col>

          {action && (
            <Col lg={4} className="text-lg-end">
              <div className="page-hero-action">
                {action}
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </section>
  );
}
